import { decodeJwt } from 'jose';

const tokenName = import.meta.env.VITE_SESSION_TOKEN_NAME;

// Decode (not verify) the token for the user's identity; the session is already
// validated server-side by verifyTokenUser() before this runs.
export const verifyToken = async () => {
  const cookies = document.cookie.split('; ').map(v => v.split(/=(.*)/s).map(decodeURIComponent));
  const cookiesMap = Object.fromEntries(cookies);
  const token = cookiesMap[tokenName];
  try {
    const { sub: userid, email, iat, role } = decodeJwt(token);
    return { userid, email, iat, role };
  } catch (err) {
    return null;
  }
};
